<sans-dashboard
  [game]="playingGame"
  [talonCards]="talonCards"
  [userCards]="userCards"
  [rightOpponentCards]="rightOpponentCards"
  [leftOpponentCards]="leftOpponentCards"
  [isUserCardsSelectable]="isUserCardsSelectable"
  (userCardSelected)="onPlayTrick($event)"
  [userPlayerScoreCard]="userPlayerScoreCard"
  [leftOpponentPlayerScoreCard]="leftOpponentPlayerScoreCard"
  [rightOpponentPlayerScoreCard]="rightOpponentPlayerScoreCard"
  [userActions]="userActions"
  (userActionSelected)="onUserActionSelected($event)"
>
</sans-dashboard>
